import React from 'react';
import { Box, Select, MenuItem, Chip, FormLabel, ListItemText } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { FILTER_TYPES } from '@/features/policies/data';

export const LatestPolicyTransactionSelect = ({ status, onChange, disabled }) => {
	const options = [
		{ value: `${FILTER_TYPES.ShowLatest}`, label: 'Latest transactions' },
		{ value: `${FILTER_TYPES.ShowAll}`, label: 'All transactions' },
	];

	const selected = options.find((opt) => opt.value === status) || options[0];

	return (
		<Box>
			{/* <FormLabel>Transaction Status</FormLabel> */}
			<Select
				fullWidth
				disabled={disabled}
				value={selected.value}
				onChange={(event) => onChange(event.target.value)}
				MenuProps={{
					// sits in front of the complete deal dialog
					sx: { zIndex: (theme) => theme.zIndex.modal + 2 },
				}}
				renderValue={(value) => {
					const option = options.find((opt) => opt.value === value);
					return (
						<Box
							sx={{
								display: 'flex',
								gap: 0.5,
								alignItems: 'center',
								overflow: 'hidden',
							}}
						>
							<Chip size='small' label={option?.label} />
						</Box>
					);
				}}
				sx={{ display: 'flex', alignItems: 'center' }}
			>
				{options.map((item) => (
					<MenuItem key={item.value} value={item.value}>
						{selected.value === item.value ? (
							<CheckBox fontSize='small' />
						) : (
							<CheckBoxOutlineBlank fontSize='small' />
						)}
						<ListItemText primary={item.label} sx={{ marginLeft: 1 }} />
					</MenuItem>
				))}
			</Select>
		</Box>
	);
};
